import styled from "styled-components";
import {TabletCalVW} from "@utils/CalVW.tsx";
import {media} from "@/styles/Qtheme.ts";

export const ProfileSettingSection = styled.div`
    width: 1200px;

    @media ${media.desktop} {
        width: ${TabletCalVW(900)};

    }
`;
